module.exports = __webpack_public_path__ + "img/anti-counterfeiting-content.a8016a75.png";